import React, { Component } from "react";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import { message, Spin, Tooltip } from "antd";
import { FaAngleRight } from "react-icons/fa";
import Bridge from "./utils/Bridge";
import { RESEARCH_TYPE } from "./utils/consts";

export default class SelectUserAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: "",
      account_list: [], 
      multiple_accounts_present: false,
      loading: false,
    };
  }
  componentDidMount() {
    if(RESEARCH_TYPE == "modality.ai" && localStorage.getItem("is_multiple_accounts_present") == "false"){
      window.location.assign("/dashboard");
      return;
    }
    this.getAvailableAccounts();
  }
  getAvailableAccounts = () => {
    this.setState({ loading: true });
    let participant_email = localStorage.getItem("ap_email");
    let params = '?email=' + participant_email + '&research_type=' + RESEARCH_TYPE;
    Bridge.participants.speech.get_available_accounts(params).then((response) => {
      if(response.status == 1){
        if(response.multiple_accounts_present==false){
          window.location.assign("/dashboard");
          return;
        }else{        
          let account_list = [];
          for(let index=0; index<response.data.length; index++){
            let item = response.data[index];
            let name= '';
            if(item.participant_name){
              name = (item.participant_name ? item.participant_name : '');
            }
            if(item.participant_name){
              name = name + ' ' + (item.participant_lname ? item.participant_lname : '');
            }
            let obj={
              name: name || 'Account ' + (index + 1),
              total_sessions: item.total_sessions,
              participants_accounts_id: item.participants_accounts_id,
            }
            account_list.push(obj);
          }          
          this.setState({ 
            account_list: account_list, 
            multiple_accounts_present: response.multiple_accounts_present,
            loading: false
          });  
        }
      }else{  
        message.warning(response.message);
        this.setState({ loading: false });
      }
    }).catch((error) => {
      this.setState({ loading: false });
    });
  }
  continue = (item) => {
    localStorage.setItem("ap_participants_accounts_id", item.participants_accounts_id);
    window.location.assign("/dashboard");
    return;
  };
  render() {
    return (
      <div>
        <Header />
        <div className="main-content select-user-account-wrapper">
          <Spin spinning={this.state.loading}>
            <div className="container">
              <div className="row mt-4">
                <div className="col-lg-12 mb-4">
                  <h3>Select your account</h3>
                  <p>
                    Multiple accounts are linked to your profile. Please choose the appropriate account to continue.
                  </p>
                </div>
                {this.state.account_list &&
                  this.state.account_list.map((item, index) => {
                    return (
                      <div className="col-lg-3 mb-2" key={item.participants_accounts_id}>
                        <div
                          className={"single-account"}
                        >
                          <div className="block">
                            <h4>{item.name} 
                              &nbsp;<Tooltip title={'Total sessions: '+ (item.total_sessions ? item.total_sessions : 0)}>({item.total_sessions ? item.total_sessions : 0})</Tooltip></h4>
                          </div>
                          <button onClick={() => this.continue(item)}>
                            CONTINUE
                            <FaAngleRight style={{ fontSize: "17px",marginTop:1,marginLeft:5 }} />
                          </button>
                        </div>
                      </div>
                    );
                })}
              </div>
            </div>
          </Spin>
        </div>
        <Footer />
      </div>
    );
  }
}
